import React from "react"
import PropTypes from "prop-types"

import { INTERFACE_ONLINE_BUTTON_NEW_SCHEDULE } from "shared/constants/idsElements"
import DefaultContainer from "shared/components/DefaultContainer"
import ModernButton from "shared/components/Button/ModernButton"
import WrapperSkeleton from "components/WrapperSkeleton"
import Typograph from "components/Typograph"

import styles from "./styles.css"

import moment from "moment"
moment.locale("pt-br")

const NoSchedule = ({ t, remainingHours, numVinculado, onClick, loading }) => {
  return (
    <WrapperSkeleton
      path="noScheduleOnlineInterface"
      isChildrenReady={!loading}
    >
      <DefaultContainer
        customClass={`Grid-cell u-flex u-flexCol ${styles.noSchedule}`}
      >
        <Typograph htmlTag="h2" weight="bold" size="medium" color="outer_space">
          {t("MY_CALLS")}
        </Typograph>
        <Typograph
          classNames={styles.endOfSchedule}
          htmlTag="p"
          size="small"
          weight="regular"
          color="outer_space"
        >
          {t("END_OF_SCHEDULE", {
            count: remainingHours,
            date: moment().endOf("month").format("DD/MM/YYYY HH:mm"),
            num: numVinculado
          })}
        </Typograph>

        <ModernButton
          id={INTERFACE_ONLINE_BUTTON_NEW_SCHEDULE}
          shape="full"
          size="large"
          buttonColor="deep_sea_green"
          text={t("NEW_SCHEDULE")}
          textColor="white"
          textSize="small"
          onClick={onClick}
          withBorderRadius
        />
      </DefaultContainer>
    </WrapperSkeleton>
  )
}

NoSchedule.propTypes = {
  t: PropTypes.func.isRequired,
  remainingHours: PropTypes.number,
  numVinculado: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool
}

export default NoSchedule



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/NoSchedule/index.js